<template>
  <div>
    <workflow-filter @change="onChange" />
    <br />
    <release-passed-rate :filter-form="filterForm" />
  </div>
</template>
<script>
import WorkflowFilter from '@/pages/data/workflow/components/WorkflowFilter';
import ReleasePassedRate from '@/pages/data/workflow/components/ReleasePassedRate';

export default {
  components: { WorkflowFilter, ReleasePassedRate },
  data() {
    return {
      filterForm: {
        begin_date: null,
        end_date: null
      }
    };
  },
  methods: {
    onChange(checkedDate, checkedTeams) {
      this.filterForm = {
        begin_date: checkedDate[0].format('YYYY-MM-DD'),
        end_date: checkedDate[1].format('YYYY-MM-DD'),
        teams: checkedTeams
      };
    }
  }
};
</script>
